import { render, staticRenderFns } from "./OtherSolicitations.vue?vue&type=template&id=b3820bb2&scoped=true"
import script from "./OtherSolicitations.vue?vue&type=script&lang=js"
export * from "./OtherSolicitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3820bb2",
  null
  
)

export default component.exports